// extracted by mini-css-extract-plugin
module.exports = {"queryBox":"TableFilter-hashed__queryBox__3B6Rk"};